import type { TFunction } from 'i18next';
import { formatFileSize } from '@/utils/formatFileSize';
import type { NameValidationError, SizeValidationError } from './validation';

// Maps the structured validation results to localized strings. Kept apart from
// `validation.ts` so the rule logic stays free of any i18n dependency.
export function nameErrorMessage(t: TFunction, err: NameValidationError): string {
  switch (err.code) {
    case 'empty':
      return t('documents.validation.nameEmpty');
    case 'invalidName':
      return t('documents.validation.invalidName');
    case 'nameTaken':
      return t('documents.validation.folderNameTaken');
    case 'tooLong':
      return t('documents.validation.nameTooLong', { max: err.max });
    case 'forbiddenChars':
      return t('documents.validation.forbiddenChars', { chars: err.chars });
  }
}

export function sizeErrorMessage(t: TFunction, err: SizeValidationError): string {
  return t('documents.validation.fileTooLarge', { max: formatFileSize(err.maxBytes) });
}
